export const planTemplateTypes: PlanTemplateType[] = ['position', 'stiffening', 'other']

export const planTypeSectionLabels: Record<PlanTemplateType, string> = {
  position: 'Positionspläne',
  stiffening: 'Aussteifungspläne',
  other: 'Lastpläne',
}

export const planTypeSingularLabels: Record<PlanTemplateType, string> = {
  position: 'Positionsplan',
  stiffening: 'Aussteifungsplan',
  other: 'Lastplan',
}

export const paperFormats: PlanTemplatePaperFormat[] = ['A1', 'A2', 'A3']

export const orientations: PlanTemplateOrientation[] = ['landscape', 'portrait']

export const orientationLabels: Record<PlanTemplateOrientation, string> = {
  landscape: 'Querformat',
  portrait: 'Hochformat',
}
